import BaseFilter from './BaseFilter'
import ContactsIcon from 'app/components/Icon/ContactsIcon'
import { FilterObject } from 'app/filter.utils'
import { staffMembersFetcher } from 'app/lib/fetchers/staffMembersFetcher'

interface ContactOwnerFilterProps {
  preAppliedValues?: string | string[]
  customSearchParam: string
  defaultFilters?: FilterObject[]
}

export default function ContactOwnerFilter({
  preAppliedValues,
  customSearchParam,
  defaultFilters,
}: ContactOwnerFilterProps) {
  return (
    <BaseFilter
      attribute="leadOwner.name"
      displayName="Contact Owners"
      icon={<ContactsIcon width={16} height={16} />}
      fetcher={staffMembersFetcher}
      optionsMapper={(res) =>
        res?.hits?.map((staff: { id: string; name: string }) => ({
          id: staff.name,
          value: staff.name,
          name: staff.name,
        })) || []
      }
      preAppliedValues={preAppliedValues}
      customSearchParam={customSearchParam}
      defaultFilters={defaultFilters}
    />
  )
}
